import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function NoResultsFoundIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="Illustration"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "60"}
      height={height || "59.905"}
      viewBox="0 0 60 59.905"
    >
      <g id="Grupo_132" data-name="Grupo 132" transform="translate(0)">
        <g id="Grupo_134" data-name="Grupo 134">
          <path
            id="Caminho_1066"
            data-name="Caminho 1066"
            d="M236.585,374a1.173,1.173,0,0,0-.829-.343,1.186,1.186,0,0,0-.829.343l-.828.827-2.692-2.688a21.11,21.11,0,1,0-4.972,4.964l2.693,2.688-.828.827a1.169,1.169,0,0,0,0,1.655l14.815,14.79a5.853,5.853,0,1,0,8.285-8.271Z"
            transform="translate(-193.118 -338.875)"
            fill="#fff"
          />
          <g id="Grupo_133" data-name="Grupo 133">
            <path
              id="Caminho_1067"
              data-name="Caminho 1067"
              d="M236.585,374a1.173,1.173,0,0,0-.829-.343,1.186,1.186,0,0,0-.829.343l-.828.827-2.692-2.688a21.11,21.11,0,1,0-4.972,4.964l2.693,2.688-.828.827a1.169,1.169,0,0,0,0,1.655l14.815,14.79a5.853,5.853,0,1,0,8.285-8.271Zm-5.8,4.137-2.509-2.505c.292-.261.577-.529.853-.8s.544-.56.805-.85l2.509,2.505Zm-29.827-4.964a18.733,18.733,0,1,1,26.514,0A18.686,18.686,0,0,1,200.957,373.174Zm34.8,3.309,3.314,3.309-4.971,4.963-3.314-3.308Zm13.985,18.927a3.514,3.514,0,0,1-4.97,0l-9.015-9,4.971-4.963,9.015,9A3.5,3.5,0,0,1,249.742,395.41Z"
              transform="translate(-193.118 -338.875)"
              fill={color || "#e2e2e2"}
            />
            <path
              id="Caminho_1068"
              data-name="Caminho 1068"
              d="M233.073,356.366a15.875,15.875,0,1,0,0,22.451A15.871,15.871,0,0,0,233.073,356.366Zm-1.6,20.846a13.608,13.608,0,1,1,0-19.243A13.6,13.6,0,0,1,231.468,377.213Z"
              transform="translate(-200.747 -346.49)"
              fill={color || "#e2e2e2"}
              stroke={color || "#e2e2e2"}
              stroke-miterlimit="10"
              stroke-width="0.5"
            />
          </g>
          <path
            id="União_22"
            data-name="União 22"
            d="M13845.842-19215.281l-4.22-4.221-4.221,4.221a1.626,1.626,0,0,1-2.3,0,1.627,1.627,0,0,1,0-2.3l4.221-4.219-4.221-4.221a1.627,1.627,0,0,1,0-2.3,1.626,1.626,0,0,1,2.3,0l4.221,4.221,4.22-4.221a1.626,1.626,0,0,1,2.3,0,1.634,1.634,0,0,1,0,2.3l-4.22,4.221,4.22,4.219a1.634,1.634,0,0,1,0,2.3,1.624,1.624,0,0,1-1.152.477A1.614,1.614,0,0,1,13845.842-19215.281Z"
            transform="translate(-13820.57 19243.428)"
            fill={color || "#e2e2e2"}
          />
        </g>
      </g>
    </svg>
  );
}
